import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "basicAuthToggle",
    "basicAuthSettings",
    "kindSelect"
  ]
  static values = { kind: String }

  connect() {
    // Ensure the initial status is valid after re-rendering a failed #create action.
    this.switchKind()
    this.toggleBasicAuth()
  }

  switchKind() {
    this.element.querySelectorAll("[data-project-creation-show-if]").forEach(element => {
      const kinds = element.dataset.projectCreationShowIf.split(",")
      element.classList.toggle("d-none", !kinds.includes(this.kind))
    })
  }

  toggleBasicAuth() {
    this.basicAuthSettingsTarget.classList.toggle("d-none", !this.basicAuthEnabled)
  }

  get basicAuthEnabled() { return this.basicAuthToggleTarget?.checked }
  get kind() {
    if (this.hasKindSelectTarget) {
      return this.kindSelectTarget.value
    } else {
      return this.kindValue
    }
  }
}
